export default __webpack_public_path__ + "static/media/Levitate D6.3 Medium term impacts of CCAM on passenger transport.f3be483b.pdf";